import { useTranslation } from 'next-i18next'

// Dependencies.
import { SectionField } from '../../Inputs/SectionField'
import { TextArea } from '../../Inputs/TextArea'
import { EventHookInterface } from '../../../types'

// Props.
interface Props {
  eventHook: EventHookInterface
}

// What You'll Do.
export const WhatYoullDo: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  // Props.
  const { eventHook } = props
  const { isEditable, value: event } = eventHook

  // State.
  const setWhatYoullDo = (value: string) => {
    eventHook.updateFieldsWithPartial({ descr: value })
  }

  // ..
  return (
    <SectionField
      header={t(`Event description`, `Event description`)}
      subheader={
        isEditable &&
        t(
          `WhatYoullDo-20220401183127765740169`,
          'Describe what attendees will be doing during the event. We recommend detailing how the attendee will be participating and suggest what they may need to bring or prepare.',
        )
      }>
      <TextArea
        onChange={setWhatYoullDo}
        placeholder={t(`Add description`, `Add description`)}
        readOnly={!isEditable}
        value={event.descr || ''}
      />
    </SectionField>
  )
}
